import React from "react";
import {Column, Row, Spinner, Text} from "react-vcomponents";
import {Rect, Vec2, Vec3} from "../ThreeJS/VectorStructs.js";
import {BaseProps, BasicStyles} from "react-vextensions";
import {observer_mgl} from "mobx-graphlink";

export function Vec2FromPartial(partial: Partial<Vec2>|n): Vec2 {
	return new Vec2(partial?.x ?? 0, partial?.y ?? 0);
}
export const Vec2Editor = observer_mgl((props: {value: Vec2|n, inputWidth?: number, onChange?: (newValue: Vec2)=>void} & BaseProps)=>{
	const {value: value_raw, inputWidth = 60, onChange} = props;
	const value = Vec2FromPartial(value_raw);

	const ChangeVec = (changer: (val: Vec2)=>void)=>{
		const newValue = new Vec2(value.x, value.y);
		changer(newValue);
		onChange?.(newValue);
	};
	return (
		<Row style={BasicStyles(props)}>
			<Text>X:</Text>
			<Spinner ml={5} style={{width: inputWidth}} min={-Infinity} value={value.x} onChange={val=>ChangeVec(a=>a.x = val)}/>
			<Text ml={5}>Y:</Text>
			<Spinner ml={5} style={{width: inputWidth}} min={-Infinity} value={value.y} onChange={val=>ChangeVec(a=>a.y = val)}/>
		</Row>
	);
});

export function Vec3FromPartial(partial: Partial<Vec3>|n): Vec3 {
	return new Vec3(partial?.x ?? 0, partial?.y ?? 0, partial?.z ?? 0);
}
export const Vec3Editor = observer_mgl((props: {value: Vec3|n, inputWidth?: number, onChange?: (newValue: Vec3)=>void} & BaseProps)=>{
	const {value: value_raw, inputWidth = 60, onChange} = props;
	const value = Vec3FromPartial(value_raw);

	const ChangeVec = (changer: (val: Vec3)=>void)=>{
		const newValue = new Vec3(value.x, value.y, value.z);
		changer(newValue);
		onChange?.(newValue);
	};
	return (
		<Row style={BasicStyles(props)}>
			<Text>X:</Text>
			<Spinner ml={5} style={{width: inputWidth}} min={-Infinity} value={value.x} onChange={val=>ChangeVec(a=>a.x = val)}/>
			<Text ml={5}>Y:</Text>
			<Spinner ml={5} style={{width: inputWidth}} min={-Infinity} value={value.y} onChange={val=>ChangeVec(a=>a.y = val)}/>
			<Text ml={5}>Z:</Text>
			<Spinner ml={5} style={{width: inputWidth}} min={-Infinity} value={value.z} onChange={val=>ChangeVec(a=>a.z = val)}/>
		</Row>
	);
});